import { DisplayOption, PresentedLoanOption } from '../types/bankingTypes';
import { formatDateWithTime } from '../../../../../../utils/DateUtils';

export function formatOptionForDisplay(
  option: PresentedLoanOption
): DisplayOption {
  const monthlyPayment = option.monthly_payment ?? 0;
  const termInMonths = option.term_in_months ?? 0;
  return {
    terms_id: option.terms_id,
    term_in_months: termInMonths,
    monthly_payment_dollars: Math.round(monthlyPayment),
    // Multiply the precise per-payment amount before rounding so the total
    // reflects the real cost. Rounding each payment to whole dollars first
    // truncated the cents and understated the total the customer signs against.
    total_cost_dollars: Math.round(monthlyPayment * termInMonths),
  };
}

// Reuses the shared datetime formatter so banking deadlines render consistently
// with the rest of the app. Preserves the empty-string contract for null dates.
export function formatDeadline(
  isoDate: string | Date | null | undefined
): string {
  if (!isoDate) return '';
  return formatDateWithTime(new Date(isoDate), true);
}
